import { AggOrder } from '../agg-order';
import { CountAggregator } from './count-aggregator';
import { SumAggregator } from './sum-aggreator';
import { MinAggregator } from './min-aggreator';
import { MaxAggregator } from './max-aggreator';
import { FirstAggregator } from './first-aggreator';
import { LastAggregator } from './last-aggreator';

import { MedianAggregator } from './median-aggreator';
import { StdDevAggregator } from './stddev-aggreator';
import { Type } from '@angular/core';
import { AvgAggregator } from './avg-aggreator';
import { ISLAggregator, AggName } from './slaggregator';



export class AggregatorFactory {
	static Names: Array<string> = ['count', 'sum', 'min', 'max', 'first', 'last', 'avg', 'median', 'stddev'];
	static Classes: Array<Type<ISLAggregator>> = [
		CountAggregator, SumAggregator, MinAggregator,
		MaxAggregator, FirstAggregator, LastAggregator,
		AvgAggregator, MedianAggregator, StdDevAggregator
	];
	public static GetAggregatorByName(aggName: AggName): Type<ISLAggregator> {
		const offset = AggregatorFactory.Names.indexOf(aggName);
		return AggregatorFactory.GetAggregatorByIndex(offset);

	}
	public static GetAggregatorByIndex(aggOrderOffset:number): Type<ISLAggregator> {
		return AggregatorFactory.Classes[aggOrderOffset];
	}
}
